import { PayloadAction } from '@reduxjs/toolkit';
import { PlanboardState } from '@reducers/v2/planboard/types';

export const addMachineToRefetchQueueAction = (
  state: PlanboardState,
  action: PayloadAction<number>
) => {
  const machineId = action.payload;
  if (!state.machineColumnsNeedingRefetch.includes(machineId)) {
    state.machineColumnsNeedingRefetch.push(machineId);
  }
};
